import {MENU_ROUTES} from '../actionType';

export default function(menuRoutes){
    return {
        type: MENU_ROUTES,
        data:menuRoutes
    }
}